import {
  editBg,
  editBgColor,
  editBgImage,
  editBgImageBlur,
  editRadius,
  editCurrentIndex,
  editDeeplink,
  editStarIndex,
  editCurrentBranchIndex
} from 'src/store/modules/imageUpload';
import {
  editColor,
  editContents,
  editFontFamily,
  editFontSize,
  editFontWeight,
  editPreFontSize,
  editSubTitle,
  editText,
  editTextAlign,
  editTitle
} from 'src/store/modules/editText';
import {
  editBtnAgain,
  editBtnBgColor,
  editBtnColor,
  editBtnFontFamily,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnPreFontSize,
  editBtnRadius,
  editBtnText,
  editBtnTextAlign
} from 'src/store/modules/buttons';
import {
  editTracking,
  editButton1,
  editButton2,
  editLogCustom
} from 'src/store/modules/trackings';
import { editUserCompany } from 'src/store/modules/client';

const setInitValue = (dispatch: any, initValue: any) => {
  // dispatch(editCurrentBranchIndex(''));
  dispatch(editCurrentIndex(0));
  // dispatch(editStarIndex(0));

  // 커스텀 폰트를 위한 초기값 설정
  if (initValue?.company) dispatch(editUserCompany(initValue?.company));

  if (initValue?.bg) dispatch(editBg(initValue?.bg));
  if (initValue?.bgColor) dispatch(editBgColor(initValue?.bgColor));
  if (initValue?.bgImage) dispatch(editBgImage(initValue?.bgImage));
  if (initValue?.bgImageBlur) dispatch(editBgImageBlur(initValue?.bgImageBlur));
  if (initValue?.deeplink) dispatch(editDeeplink(initValue?.deeplink));
  if (initValue?.radius) dispatch(editRadius(initValue?.radius));
  if (initValue?.text) dispatch(editText(initValue?.text));
  if (initValue?.fontSize) dispatch(editPreFontSize(initValue?.fontSize));
  if (initValue?.fontSize) dispatch(editFontSize(initValue?.fontSize));
  if (initValue?.fontWeight) dispatch(editFontWeight(initValue?.fontWeight));
  if (initValue?.color) dispatch(editColor(initValue?.color));
  if (initValue?.fontFamily) dispatch(editFontFamily(initValue?.fontFamily));
  if (initValue?.textAlign) dispatch(editTextAlign(initValue?.textAlign));

  if (initValue?.btnText) dispatch(editBtnText(initValue?.btnText));
  if (initValue?.btnFontSize)
    dispatch(editBtnPreFontSize(initValue?.btnFontSize));
  if (initValue?.btnFontSize) dispatch(editBtnFontSize(initValue?.btnFontSize));
  if (initValue?.btnFontWeight)
    dispatch(editBtnFontWeight(initValue?.btnFontWeight));
  if (initValue?.btnColor) dispatch(editBtnColor(initValue?.btnColor));
  if (initValue?.btnBgColorR)
    dispatch(
      editBtnBgColor(
        initValue?.btnBgColorR,
        initValue?.btnBgColorG,
        initValue?.btnBgColorB,
        initValue?.btnBgColorA
      )
    );
  if (initValue?.btnFontFamily)
    dispatch(editBtnFontFamily(initValue?.btnFontFamily));
  if (initValue?.btnTextAlign)
    dispatch(editBtnTextAlign(initValue?.btnTextAlign));
  if (initValue?.btnAgain) dispatch(editBtnAgain(initValue?.btnAgain));

  if (initValue?.tracking) dispatch(editTracking(initValue?.tracking));
  if (initValue?.button1) dispatch(editButton1(initValue?.button1));
  if (initValue?.button2) dispatch(editButton2(initValue?.button2));
  if (initValue?.logCustom) dispatch(editLogCustom(initValue?.logCustom));
};

export default setInitValue;
